/**
 * Hashtag Research — Learn-Mode inline tips.
 *
 * Anchored in `routes/social/HashtagResearch.tsx`.
 */

import type { LearnTip } from "./types";

export const hashtagsTips: LearnTip[] = [
  {
    key: "social-hashtag-sets",
    title: "Saved Sets",
    body: "Reusable groups of hashtags you've saved for this client — select tags below and “Save as set” to build one, then reuse it with a single click next time instead of re-researching.",
  },
  {
    key: "social-hashtag-selection",
    title: "Selected Hashtags",
    body: "The hashtags you've picked so far. Copy them, save them as a reusable set, or send them straight into a new post.",
  },
];
